module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'toggle'
	],

	methods: {
		prepareStaticOptions: function(dataType, dataFlag){
			var self = this;

			// reset potential defaultOptionEntry
			if((self.model.renderConfig || {}).defaultOptionEntry){
				delete self.model.renderConfig.defaultOptionEntry;
			}

			// force selection to "keep"
			self.model.value = 0;

			// force childConfig to keep right config
			self.model.childConfig.name = 'name';
			self.model.childConfig.value = 'value';

			// set steatic options
			self.model[dataFlag] = {
				options: [
					{ name: storage.__('dataValues.newsletter.subscriber.removeMassProperty.0'), value: 0, defaultSelected: true },
					{ name: storage.__('dataValues.newsletter.subscriber.removeMassProperty.1'), value: 1, defaultSelected: false }
				]
			};
		}
	}
};